/**************************************************
 * Nombre:       Tarjeta_Imagen_Reserva
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import 'react-medium-image-zoom/dist/styles.css'
import {formatoMoneda} from "../../Utilidades/formatoMoneda";

const Tarjeta_Imagen_Reserva = ({item}) => {

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-end'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                background: `url(${item.img})`,
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                height: 450
            }}
        >


            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}
                    sx={{
                        background: "linear-gradient(0deg, #000 20.7%, rgba(0, 0, 0, 0.00) 67.98%)",
                        color: '#fff',
                        p: 3
                    }}
                >

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                        <Typography sx={{fontSize: 28, fontWeight: 800}}>{item.numero}</Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                        <Typography sx={{fontSize: 14, fontWeight: 300, lineHeight: 1.1}}>
                            {item.detalles}
                        </Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 1}}>
                        <Typography sx={{
                            fontSize: 20,
                            fontWeight: 800
                        }}>{`Valor Noche: ${formatoMoneda(item.tarifa)} USD`}</Typography>
                    </Grid>


                </Grid>
            </Grid>

        </Grid>
    )

}
export default Tarjeta_Imagen_Reserva